"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function addValidationRule(target, paramIndex, rule) {
    var metaKey = "validation:" + paramIndex;
    var validationRules = Reflect.getMetadata(metaKey, target);
    if (!validationRules) {
        validationRules = [];
    }
    validationRules.push(rule);
    Reflect.defineMetadata(metaKey, validationRules, target);
}
exports.addValidationRule = addValidationRule;
